if(jQuery('#waveform').length){
    var wavesurfer = WaveSurfer.create({
          container: '#waveform',
          waveColor: 'violet',
          progressColor: 'purple',
          backend: 'MediaElement'
      });
      wavesurfer.setVolume(0.5);
}



var testscope = false;
var testscope2 = false;

angular.module('procommTalentSearch', ['ngDialog', 'ng-slide-down', 'matchMedia']);

